import {
  displayWeekdayDigitMonthAndDay,
  formatPrice
} from "@website/accommodation-ui/price-calendar-wrapper/price-box/helpers";
import { PriceCalendarItem } from "@website/accommodation-ui/price-calendar-wrapper/types";

const PriceBoxBgColor = {
  normal: "bg-white",
  worstPrice: "bg-transparent-error",
  bestPrice: "bg-transparent-success"
};

const PriceColor = {
  normal: "text-gray",
  worstPrice: "text-error",
  bestPrice: "text-success"
};

export const usePriceBox = (properties: PriceCalendarItem) => {
  const { date, price, status, onClick } = properties;

  const handleClick = () => onClick(properties);

  return {
    formattedDate: displayWeekdayDigitMonthAndDay(date),
    formattedDateMobile: displayWeekdayDigitMonthAndDay(date, true),
    formattedPrice: formatPrice(price),
    priceBoxBgColor: PriceBoxBgColor[status],
    priceColor: PriceColor[status],
    handleClick
  };
};
